<template>
    <div>
        <!-- <div class="w-full" style="position: sticky; top: 0; z-index: 9999;">
            <div v-if="$page.props.auth?.user?.needs_password_change" class="flex items-center justify-center w-full shadow-lg" style="background-color: #BC282E; min-height: 60px;">
                <div class="flex items-center">
                    <svg class="w-4 h-4 ml-4 mr-2 shrink-0 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                    </svg>
                    <div class="py-4 mr-4 font-medium text-center text-white">
                        <div class="flex items-center justify-center space-x-4">
                            <span class="text-lg font-bold">🔒 SECURITY ALERT</span>
                            <span class="text-sm">You must change your password to continue using the system.</span>
                            <button 
                                @click="changePassword" 
                                class="px-4 py-2 font-bold text-red-700 transition-colors bg-white rounded-md shadow-md hover:bg-gray-100"
                            >
                                CHANGE PASSWORD NOW
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import { Inertia } from '@inertiajs/inertia'

export default {
    methods: {
        changePassword() {
            Inertia.visit(route('password.change'))
        }
    }
}
</script>

<style scoped>
/* Custom styles if needed */
.transition-colors {
    transition-property: color, background-color, border-color;
}
</style>